import { StoreContext } from 'src/stores';
import { AppStore } from 'src/stores';
import { initializeStore } from 'src/stores/app.module';
import { Header, Footer } from '../core/components';
import { TryZyn } from 'src/core/modules';
import { createBrowserHistory } from 'history';

/**
 * History
 */
const history = createBrowserHistory();

/**
 * <Provider />
 */
const App = () => {
  let store: AppStore;

  const _store = initializeStore(store);

  return (
    <StoreContext.Provider value={_store}>
      <>
        <Header />
        <TryZyn />
        <Footer />
      </>
    </StoreContext.Provider>
  );
};

export { App };
